// import services from '@/store/mockup/define/services';
// import teams from '@/store/mockup/define/teams';
// import jobs from '@/store/mockup/define/jobs';
// import members from '@/store/mockup/define/members';

import filterJobView from '@/filters/getJobViewData';
import filterTeamView from '@/filters/getTeamViewData';
import filterMemberView from '@/filters/getMemberViewData';

import {
  INITIALIZE_USER,
  SET_LOGIN_USER_DATA,
  SET_CONFIG_DATA,

  SET_COMPANIES_DATA,
  SET_GROUP_DATA,
  SET_CATEGORIES_DATA,
  SET_TEAMS_DATA,
  SET_POSITIONS_DATA,
  SET_JOBS_DATA,
  SET_SERVICES_DATA,
  SET_MEMBERS_DATA,
  SET_MEMBERS_WITH_AUTHORITY_DATA,
  SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA,
  SET_SELECTED_MEMBER_DATA,

  ADD_MEMBERS_DATA,
  EDIT_MEMBERS_DATA,

  CREATE_JOBS_DATA,
  EDIT_JOBS_DATA,
  REMOVE_JOBS_DATA,

  CREATE_TEAMS_DATA,
  EDIT_TEAMS_DATA,
  REMOVE_TEAMS_DATA,

  // loading
  SET_LOADING,
  // 사용자 알림
  SET_MESSAGE,
} from './mutation-types';

export default {
  [INITIALIZE_USER](state, res) {
    // console.log('INITIALIZE_USER (action) =========================== ', res);
    const payload = res.data.data;

    if (payload.user) {
      this.commit('SET_LOGIN_USER_DATA', payload.user);
      this.commit('SET_COMPANIES_DATA', payload.user.companies);

      console.log('payload.user = ', payload.user);

      if (Object.keys(state.loginUser.permission).length > 0) {
        if (state.route.hash !== '') {
          Object.keys(state.companies).forEach((companyId) => {
            if (state.route.hash.indexOf(companyId) > -1) {
              state.base.company = state.companies[companyId].id;
            }
          });
        } else {
          state.base.company = payload.user.company;
        }
        this.dispatch('GET_CONFIG_DATA');
      } else {
        alert('권한이 없습니다. 담당자(이형주)에게 문의 주세요.');
      }
    } else {
      alert('google Login이 필요 합니다.');
      window.location.href = `${state.base.baseUrl}/admin/login`;
    }
  },

  [SET_LOGIN_USER_DATA](state, payload) {
    // console.log('SET_LOGIN_USER_DATA(mutation) =========================== ', payload);
    state.loginUser = { ...payload };
  },

  [SET_CONFIG_DATA](state, payload) {
    // console.log('SET_CONFIG_DATA(mutation) =========================== ', payload);
    // this.commit('SET_COMPANIES_DATA', payload.companies);
    this.commit('SET_GROUP_DATA', payload.group);
    this.commit('SET_SERVICES_DATA', payload.services);
    this.commit('SET_CATEGORIES_DATA', payload.categories);
    this.commit('SET_POSITIONS_DATA', payload.positions);
    this.commit('SET_JOBS_DATA', payload.jobs);
    this.commit('SET_TEAMS_DATA', payload.teams);
    this.commit('SET_MEMBERS_DATA', payload.members);
  },

  [SET_JOBS_DATA](state, payload) {
    // console.log('SET_JOBS_DATA(mutation) =========================== ', payload);
    const ogrJobs = payload;
    const stateJobs = {};

    Object.keys(ogrJobs).forEach((jobId) => {
      stateJobs[jobId] = filterJobView.setJobView(ogrJobs[jobId], state.services);
    });
    state.jobs = stateJobs;
  },

  [SET_COMPANIES_DATA](state, payload) {
    console.log('SET_COMPANIES_DATA(mutation) =========================== ', payload);
    state.companies = payload;
  },

  [SET_POSITIONS_DATA](state) {
    // console.log('SET_POSITIONS_DATA(mutation) =========================== ', payload);
    // const newPositions = payload;
    const newPositions = {
      manager: {
        name: '책임자',
        useType: true,
        level: 50,
        explain: '',
      },
      admin: {
        name: '서비스 관리자',
        useType: true,
        level: 50,
        explain: '',
      },
      staff: {
        name: '팀원',
        useType: true,
        level: 50,
        explain: '',
      },
      intern: {
        name: '인턴',
        useType: true,
        level: 50,
        explain: '',
      },
      outsider: {
        name: '외부인',
        useType: true,
        level: 50,
        explain: '',
      },
    };
    state.positions = newPositions;
  },

  [SET_GROUP_DATA](state) {
    // console.log('SET_GROUP_DATA(mutation) =========================== ', payload);
    // const newGroup = payload;
    const newGroup = {
      1: {
        name: '개발1',
      },
      2: {
        name: '개발2',
      },
      3: {
        name: '개발3',
      },
      4: {
        name: '개발4',
      },
      5: {
        name: '기술',
      },
      6: {
        name: '데이터분석',
      },
      7: {
        name: '재무',
      },
      8: {
        name: '대외커뮤니케이션',
      },
      9: {
        name: '사업총괄',
      },
    };

    state.groups = newGroup;
  },

  [SET_CATEGORIES_DATA](state) {
    // console.log('SET_CATEGORIES_DATA(mutation) =========================== ', payload);
    // const newGroup = payload;
    const categories = {
      planner: { useType: true, name: '기획', level: 40, explain: '' },
      business: { useType: true, name: '사업', level: 40, explain: '' },
      designer: { useType: true, name: '디자인', level: 40, explain: '' },
      developer: { useType: true, name: '개발', level: 40, explain: '' },
      manager: { useType: true, name: '관리', level: 50, explain: '' },
      security: { useType: true, name: '보안', level: 70, explain: '' },
      marketer: { useType: true, name: '마케팅', level: 40, explain: '' },
      data: { useType: true, name: '데이터', level: 40, explain: '' },
      ml: { useType: true, name: '머신러닝', level: 40, explain: 'Machine Learning' },
      hr: { useType: true, name: '인사', level: 70, explain: 'Human Resources' },
      qa: { useType: true, name: '품질보증', level: 70, explain: 'Quality Assurance' },
      cs: { useType: true, name: '고객서비스', level: 70, explain: 'Customer Service' },
      accounting: { useType: true, name: '회계', level: 70, explain: '' },
      sound: { useType: false, name: '음악', level: 70, explain: '' },
      funding: { useType: false, name: '자금', level: 70, explain: '' },
      general: { useType: false, name: '총무 삭제', level: 70, explain: '' },
      pr: { useType: false, name: '홍보', level: 40, explain: 'Public Relations' },
      ga: { useType: false, name: '총무', level: 40, explain: 'General Affairs' },
      ja: { useType: false, name: '법무 삭제', level: 40, explain: 'Legal Affairs' },
      la: { useType: false, name: '법무', level: 40, explain: 'Legal Affairs' },
      ir: { useType: false, name: '기업활동', level: 40, explain: 'Investor Relations' },
      sc: { useType: false, name: '사회공헌', level: 40, explain: 'Social Contribution' },
      admin: { useType: false, name: '서비스관리', level: 90, explain: '' },
      unclassified: { useType: false, name: '미분류', level: 40, explain: '' },
    };

    state.categories = categories;
  },

  [SET_TEAMS_DATA](state, payload) {
    // console.log('SET_TEAMS_DATA(mutation) =========================== ', payload);
    const ogrTeams = payload;
    const stateTeams = {};

    Object.keys(ogrTeams).forEach((teamId) => {
      stateTeams[teamId] = filterTeamView.setTeamView(ogrTeams[teamId], state.services);
    });
    state.teams = stateTeams;
  },

  [SET_SERVICES_DATA](state, payload) {
    // console.log('SET_SERVICES_DATA(mutation) =========================== ', payload);
    const ogrServices = payload;

    Object.keys(ogrServices).forEach((serviceId) => {
      const rangTags = [];

      ogrServices[serviceId].domain = {};
      Object.keys(ogrServices[serviceId].range_group).forEach((rangeId) => {
        ogrServices[serviceId].range_group[rangeId].tag.forEach((currentTag) => {
          if (!rangTags.includes(currentTag)) {
            rangTags.push(currentTag);
          }
        });
        ogrServices[serviceId].domain[rangeId] = ogrServices[serviceId].action_group;
      });
      ogrServices[serviceId].rang_tags = rangTags;
    });
    state.services = ogrServices;
  },

  [SET_MEMBERS_DATA](state, payload) {
    // console.log('SET_MEMBERS_DATA(mutation) =========================== ', payload);
    const ogrMembers = payload;
    const stateMembers = [];

    ogrMembers.forEach((member) => {
      // if (
      //   // member.id === 'STZ120' ||
      //   // member.id === 'STZ408' ||
      //   // member.id === 'STZ474' ||
      //   // member.id === 'STZ610' ||
      //   // member.id === 'STZ111' ||
      //   // member.id === 'STZ288' ||
      //   // member.id === 'STZ133' ||
      //   // member.id === 'STZ286' ||
      //   // member.id === 'STZ411' ||
      //   // member.id === 'STZ124' ||
      //   // member.id === 'STZ221' ||
      //   member.id === 'STZ422' ||
      //   member.id === 'STZ434' ||
      //   member.id === 'STZ558'
      // ) {
      //   stateMembers.push(filterMemberView.setMemberView(member, state.services, state.teams));
      // }
      stateMembers.push(filterMemberView.setMemberView(member, state.services, state.teams));
    });
    state.members = stateMembers;
  },

  [SET_MEMBERS_WITH_AUTHORITY_DATA](state, payload) {
    console.log('SET_MEMBERS_WITH_AUTHORITY_DATA(mutation) =========================== ', payload);
    state.membersWithAuthority = payload;
  },

  [SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA](state, payload) {
    console.log('SET_LOG_OF_MEMBER_WITH_AUTHORITY_DATA(mutation) =========================== ', payload);
    state.logOfMemberWithAuthority = payload;
  },

  [ADD_MEMBERS_DATA](state, payload) {
    // console.log('ADD_MEMBERS_DATA(mutation) =========================== ', payload);
    const stateMembers = [];

    state.members.forEach((member) => {
      if (member.id === payload.id) {
        this.commit('SET_SELECTED_MEMBER_DATA', payload);
        stateMembers.push(state.member);
      } else {
        stateMembers.push(member);
      }
    });
    state.members = stateMembers;
  },

  [EDIT_MEMBERS_DATA](state, payload) {
    // console.log('EDIT_MEMBERS_DATA(mutation) =========================== ', payload);
    const stateMembers = [];

    state.members.forEach((member) => {
      if (payload.id === member.id) {
        this.commit('SET_SELECTED_MEMBER_DATA', payload);
        stateMembers.push(state.selectedMember);
      } else {
        stateMembers.push(member);
      }
    });
    state.members = stateMembers;
  },

  [SET_SELECTED_MEMBER_DATA](state, payload) {
    // console.log('SET_SELECTED_MEMBER_DATA(mutation) =========================== ', payload);
    let newData = null;
    const viewData = filterMemberView.makeMemberBasicViewData(state.services);

    if (payload) {
      const insertMember = JSON.parse(JSON.stringify(payload));
      const orgData = filterMemberView.setMemberView(payload, state.services, state.teams);

      if ({}.hasOwnProperty.call(payload, 'request')) {
        payload.request.forEach((requestAffiliatedTeam) => {
          const agreements = [];

          requestAffiliatedTeam.agreements.forEach((agreement) => {
            if (!agreement.agree) {
              agreements.push(agreement);
            }
          });
          insertMember.affiliatedTeams[requestAffiliatedTeam.id] = { ...requestAffiliatedTeam, agreements };
        });
      }
      newData = filterMemberView.setMemberView(insertMember, state.services, state.teams);
      Object.keys(newData.affiliatedTeams).forEach((teamId) => {
        Object.keys(newData.affiliatedTeams[teamId].viewData).forEach((serviceId) => {
          Object.keys(newData.affiliatedTeams[teamId].viewData[serviceId]).forEach((domainId) => {
            Object.keys(newData.affiliatedTeams[teamId].viewData[serviceId][domainId]).forEach((actionId) => {
              const orgViewAction = orgData.affiliatedTeams[teamId].viewData[serviceId][domainId][actionId];
              const newViewAction = newData.affiliatedTeams[teamId].viewData[serviceId][domainId][actionId];

              if (orgViewAction.selected) {
                viewData[serviceId][domainId][actionId].selected = true;
                viewData[serviceId][domainId][actionId].isDefault = true;
              }
              newViewAction.isDefault = orgViewAction.isDefault;
            });
          });
        });
      });
      newData.viewData = viewData;
    }
    state.selectedMember = newData;
  },

  [CREATE_JOBS_DATA](state, payload) {
    // console.log('CREATE_JOBS_DATA(mutation) =========================== ', payload);
    const newJob = payload;

    state.jobs = { ...state.jobs, newJob };
  },

  [EDIT_JOBS_DATA](state, payload) {
    // console.log('EDIT_JOBS_DATA(mutation) =========================== ', payload);
    const stateJobs = {};

    Object.keys(state.jobs).forEach((jobId) => {
      if (payload.id === jobId) {
        stateJobs[jobId] = payload;
      } else {
        stateJobs[jobId] = state.jobs[jobId];
      }
    });
    state.jobs = stateJobs;
  },

  [REMOVE_JOBS_DATA](state, payload) {
    // console.log('REMOVE_JOBS_DATA(mutation) =========================== ', payload);
    const newJob = payload;

    delete state.jobs[newJob];
  },

  [CREATE_TEAMS_DATA](state, payload) {
    // console.log('CREATE_TEAMS_DATA(mutation) =========================== ', payload);
    const newTeam = payload;

    state.teams = { ...state.teams, newTeam };
  },

  [EDIT_TEAMS_DATA](state, payload) {
    // console.log('EDIT_TEAMS_DATA(mutation) =========================== ', payload);
    const stateTeams = {};

    Object.keys(state.teams).forEach((teamId) => {
      if (payload.id === teamId) {
        stateTeams[teamId] = payload;
      } else {
        stateTeams[teamId] = state.teams[teamId];
      }
    });
    state.teams = stateTeams;
  },

  [REMOVE_TEAMS_DATA](state, payload) {
    // console.log('REMOVE_TEAMS_DATA(mutation) =========================== ', payload);
    const newTeam = payload;

    delete state.teams[newTeam];
  },

  // loading
  [SET_LOADING](state, payload) {
    // console.log('SET_LOADING_START (mutation) =========================== ', payload);
    state.isLoading = payload;
  },

  // 사용자 알림
  [SET_MESSAGE](state, payload) {
    console.log('SET_MESSAGE(mutation) =========================== ', payload);
    state.message[payload.method] = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/mutation.js